/**
 * 三包登记的 表单验证规则
 * @author zjs
 * @time 2017-09-21
 */
export default {
    data () {
        // 非空的判断
        // var isNoEmpty = (rule, value, callback) => {
        //     if (value === '') {
        //         callback(new Error('请输入'))
        //     } else {
        //         callback()
        //     }
        // }
        return {
            formRules: {
                work_time: [{ required: true, trigger: 'blur' }],
                'account.label' : [{ required: true, trigger: 'blur' }],
                'account.account_number' : [{ required: true, trigger: 'blur' }],
                account_type: [{ required: true, trigger: 'blur' }]
            }
        }
    }
}